import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import TrafficSignsMessagesModel from './TrafficSignsMessagesModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Statistic, Popconfirm, message } from 'antd';

class LcSignsMessagesTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {}
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Seriové číslo',
            dataIndex: 'serialNumber',
            key: 'serialNumber',
            width: 170,
            sorter: (a, b) => defaultSorter(a.serialNumber, b.serialNumber),
        }, {
            title: 'Původní hodnota',
            dataIndex: 'oldValue',
            width: 200,
            key: 'oldValue',
        }, {
            title: 'Nová hodnota',
            dataIndex: 'value',
            width: 200,
            key: 'value',
        }, {
            title: 'Čas MQTT',
            dataIndex: 'lastMqttStamp',
            key: 'lastMqttStamp',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.lastMqttStamp, b.lastMqttStamp),
            render: (text, record) => {
                return moment(text).format('L LTS');
            }
        }, {
            title: 'Čas odeslání do značky',
            dataIndex: 'lastSendStamp',
            key: 'lastSendStamp',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.lastSendStamp, b.lastSendStamp),
            render: (text, record) => {
                return moment(text).format('L LTS');
            }
        }]

        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    style={{ border: '0px' }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    onChange={this.handleChange} />
            </div>
        );
    }
}

export default LcSignsMessagesTable;


// WEBPACK FOOTER //
// ./src/components/LcSignsMessagesTable.js